import React from 'react';
import { Loader2, History } from 'lucide-react';
import { Button } from '../../../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../../../ui/dialog';

export const TemplateDialog = ({ open, onOpenChange, templates, selected, onSelect, onCreate, saving }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-md" data-testid="template-dialog">
      <DialogHeader>
        <DialogTitle>Create Collection from Template</DialogTitle>
      </DialogHeader>
      <div className="space-y-4 py-4">
        <p className="text-sm text-neutral-500">Select a template to quickly create a new collection with pre-defined materials</p>
        <div className="space-y-2">
          {templates.length === 0 ? (
            <p className="text-sm text-neutral-400 text-center py-4">No templates available</p>
          ) : templates.map(t => (
            <button
              key={t.id} onClick={() => onSelect(t.id)} data-testid={`template-${t.id}`}
              className={`w-full text-left p-3 rounded-lg border transition-all ${selected === t.id ? 'border-amber-500 bg-amber-50' : 'border-neutral-200 hover:border-neutral-300'}`}
            >
              <p className="font-medium">{t.name}</p>
              <p className="text-xs text-neutral-500">{t.description}</p>
              <p className="text-xs text-amber-600 mt-1">{t.materials_count} materials</p>
            </button>
          ))}
        </div>
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
        <Button onClick={onCreate} disabled={saving || !selected} className="bg-amber-600 hover:bg-amber-700" data-testid="template-create-btn">
          {saving ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : null}
          Create Collection
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export const PriceHistoryDialog = ({ open, onOpenChange, history, loading }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-md" data-testid="price-history-dialog">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2"><History className="w-5 h-5" /> Price History</DialogTitle>
      </DialogHeader>
      <div className="py-4">
        {loading ? (
          <div className="flex justify-center py-8"><Loader2 className="w-6 h-6 animate-spin text-amber-600" /></div>
        ) : history.length === 0 ? (
          <p className="text-sm text-neutral-500 text-center py-8">No price history available</p>
        ) : (
          <div className="space-y-3">
            {history.map((record, idx) => (
              <div key={record.id || idx} className="border rounded-lg p-3 bg-neutral-50">
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium">${record.old_price?.toFixed(2) || '—'} → ${record.new_price?.toFixed(2)}</span>
                  <span className={`text-xs px-2 py-0.5 rounded-full ${record.change_type === 'bulk_update' ? 'bg-blue-100 text-blue-700' : 'bg-green-100 text-green-700'}`}>
                    {record.change_type === 'bulk_update' ? 'Bulk Update' : 'Manual Edit'}
                  </span>
                </div>
                {record.notes && <p className="text-xs text-neutral-500 mt-1">{record.notes}</p>}
                <p className="text-xs text-neutral-400 mt-1">{record.created_at ? new Date(record.created_at).toLocaleString() : 'Unknown date'}</p>
              </div>
            ))}
          </div>
        )}
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)}>Close</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
